import { DATA_STORE_KEYS, DataStore } from '@providers/dataStore';
import { CONTAINER_TYPE, ROLE_GROUP } from '../constants';

export const mapJobTitleToRole = jobTitle => {
    if (DataStore.getItem(DATA_STORE_KEYS.IS_LOGGEDIN) === 'false') {
        return CONTAINER_TYPE.LOGIN;
    }

    if (!jobTitle) {
        return CONTAINER_TYPE.EMPLOYEE;
    }

    const normalizedTitle = jobTitle.toLowerCase();

    if (ROLE_GROUP.ADMIN.includes(normalizedTitle)) {
        return CONTAINER_TYPE.ADMIN;
    }
    // if (ROLE_GROUP.HR.includes(normalizedTitle)) {
    //     return CONTAINER_TYPE.HR;
    // }
    if (ROLE_GROUP.MANAGER.includes(normalizedTitle)) {
        return CONTAINER_TYPE.MANAGER;
    }
    if (ROLE_GROUP.WFM.includes(normalizedTitle)) {
        return CONTAINER_TYPE.WFM;
    }
    if (ROLE_GROUP.EMPLOYEE.includes(normalizedTitle)) {
        return CONTAINER_TYPE.EMPLOYEE;
    }
    if (ROLE_GROUP.RECRUITERS.includes(normalizedTitle)) {
        return CONTAINER_TYPE.RECRUITER;
    }

    return CONTAINER_TYPE.LOGIN; // fallback
};
